module.exports = __webpack_public_path__ + "static/media/contact-banner-image.bde4bca5.png";